export class ApiRequestError extends Error {
  constructor(
    readonly status: number,
    readonly code: string,
    message: string,
    readonly details?: unknown,
  ) {
    super(message);
  }
}

/**
 * A refusal of what was sent (invalid, taken, over a limit): it belongs under
 * the field. 401/403 are about the session, 5xx and network failures about
 * the server; those go to a toast (`notifyError`), never under a field.
 */
export function isFieldError(e: unknown): e is ApiRequestError {
  return (
    e instanceof ApiRequestError &&
    e.status >= 400 &&
    e.status < 500 &&
    e.status !== 401 &&
    e.status !== 403
  );
}

export function errorMessage(e: unknown): string {
  return e instanceof ApiRequestError ? `${e.message} (${e.code})` : 'Something went wrong';
}
